import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

import Link from '@mui/material/Link'
import AssignmentTypeIcon from 'components/elements/AssignmentTypeIcon'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))

export default function AssignmentLink(props) {

  return (
    <Item elevation={props.elevation || 0}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="flex-start"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Typography variant="primary">
          <AssignmentTypeIcon
            type={props.assignment_type}
            fullType={props.full_type}
          />
        </Typography>
        <Typography variant="primary">
          [{props.id}]
        </Typography>
        <Typography variant="primary">
          <Link to={`/assignments/details/${props.id}`} component={RouterLink}>{props.name}</Link>
        </Typography>
      </Stack>
    </Item>
  )
}
